import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

function DefaultErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  console.error(error);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <section className="max-w-md text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Aguarde um instante</p>
        <h1 className="mt-4 text-2xl font-semibold">A página não carregou agora</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Tivemos uma instabilidade momentânea. Tente recarregar a página.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <button className="btn-gold px-5 py-3 text-sm" onClick={reset}>
            Tentar novamente
          </button>
          <a className="rounded-md border border-gold/25 px-5 py-3 text-sm text-foreground" href="/">
            Voltar ao início
          </a>
        </div>
      </section>
    </main>
  );
}

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: DefaultErrorComponent,
  });

  return router;
};
